import React from 'react';

import type { DrawReactComponentProps } from '@aline/common';
import { AlineTransforms } from '@aline/common';
import { IconButton } from '@mui/material';
import { AlineTooltip } from 'src/components';
import { SynchronizeIcon } from 'src/components/icons/SynchronizeIcon';
import { useEditor } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  button: {
    background: 'white !important',
    border: `1px solid ${theme.appColors.rule}`,
    boxShadow: theme.appShadows.popper,
    padding: 11,
    transform: 'translateX(-100%)',
  },
  icon: {
    height: 18,
    width: 18,
  },
}));

export function UpdateTableOfContentsButton({
  tableOfContentsEntry,
}: DrawReactComponentProps['UpdateTableOfContentsButton']) {
  const editor = useEditor();
  const { classes } = useStyles();

  return (
    <AlineTooltip arrow placement="bottom" title="Update table of contents">
      <IconButton
        aria-label="Update table of contents"
        className={classes.button}
        size="small"
        onClick={() => AlineTransforms.updateToc(editor, tableOfContentsEntry)}
      >
        <SynchronizeIcon className={classes.icon} />
      </IconButton>
    </AlineTooltip>
  );
}
